<template>
  <div class="container-fluid">
    <b-card no-body>
      <b-card-header>
        <h1 class="text-center">{{ service.name }}</h1>
        <br>
      </b-card-header>
      <b-card-body>
        <div class="mb-3">
          <div v-html="barcodeHTML" class="text-center"></div>
          <div v-text="service.barcode" class="text-center"></div>
        </div>

        <b-row>
          <b-col>Stok</b-col>
          <b-col>
            <div>
              <span v-if="service.stock === -1">{{ $t('Limitsiz') }}</span>
              <div v-else class="d-flex align-items-center">
                <!--              <span>{{ service.stock - service.active_lease_count }}</span>-->
                <span>{{ service.active_stock }}</span>
                <div>
                  <div>

                    <b-badge v-if="service.active_lease_count > 0" class="ml-2"
                             variant="warning">+ {{ service.active_lease_count }} {{ $t("Adet Kirada") }}
                    </b-badge>
                  </div>
                  <div>

                    <b-badge v-if="service.active_tailor_count > 0" class="ml-2"
                             variant="info">+ {{ service.active_tailor_count }} {{ $t("Adet Terzide") }}
                    </b-badge>
                  </div>
                  <div>
                    <b-badge v-if="service.active_dry_count > 0" class="ml-2"
                             variant="primary">+ {{ service.active_dry_count }} {{ $t("Adet Kuru Temizlemede") }}
                    </b-badge>

                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>{{ $t('Kategori') }}</b-col>
          <b-col v-text="service.category.name"></b-col>
        </b-row>
        <b-row>
          <b-col>{{ $t('Satış Fiyatı') }}</b-col>
          <b-col v-text="service.price+' TL'"></b-col>
        </b-row>
        <b-row>
          <b-col>{{ $t('Kira Fiyatı') }}</b-col>
          <b-col v-text="service.rent_price+' TL'"></b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card v-for="(rent,i) in rents" v-bind:key="rent.id" class="my-3">

      <b-card-body>

        <h2>#{{ i+1 }}</h2>
        {{ $t('Kiraya Verilen Kişi') }}: {{ rent.client.full_name}}<br>
        {{ $t('Telefon Numarası') }}:  {{ rent.client.gsm.replace(' ','').replace('(','').replace(')','').replace('+9','')}}  <br>
        {{ $t('Verilen Tarih') }} : {{ rent.issue_date}} <br>
        {{ $t('Teslim Alınacak Tarih') }} : {{ rent.delivery_date}} <br>
        {{ $t('Toplam Fiyat') }} : {{ rent.total_price}} TL <br>
        <span :class="'badge badge-'+(rent.status=='active' ? 'success' : 'warning')">
          {{ rent.status == 'active' ? '' : 'Teslim Alındı' }}
        </span>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";

export default {
  computed: {
    productId() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions(['getServices','createBarcodeHTML','getLeasesByService']),
    getLeases(item){
      this.getLeasesByService(item.id).then(res => {
        this.activeItem = item.name;
        this.rents = res.data;
        this.rents.forEach(rent => {
          rent.issue_date = moment(rent.issue_date).format('DD-MM-YYYY')
          rent.delivery_date = moment(rent.delivery_date).format('DD-MM-YYYY')
        })
      })
    },
    createBarcode(){
      this.createBarcodeHTML(this.service.barcode).then(response => {
        this.barcodeHTML = response.data;
      }).catch(error => {
        this.error(error.response.data.message);
      })
    }

  },
  data() {
    return {
      service: {},
      barcodeHTML: null,
      rents:[]
    }
  },
  mounted() {
    this.getServices({
      page: 1,
      perPage: 7,
      order_by_stock: 2,
      brand: 'all',
      category: 'all',
      service_id: this.productId,
    }).then(res => {
      let service = res.data.services.data
      if (service.length < 1)
        window.location.href = '/'
      this.service = service[0]
      this.createBarcode()
      this.getLeases(this.service)

    })
  }
}
</script>

<style scoped>
  .row{
    padding:1.2rem 0;
    border-top:0.1px solid gray
  }
</style>